module.exports = __webpack_public_path__ + "static/media/Aroha-bw.a6d6ef4d.png";